// src/store/authStore.js
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import axios from 'axios';

// تنظیم پیش‌فرض axios برای ارسال توکن
axios.defaults.baseURL = '/api'; // تغییر بده به آدرس واقعی backend

const useAuthStore = create(
  persist(
    (set, get) => ({
      // وضعیت اولیه
      user: null,
      accessToken: null,
      isLoggedIn: false,
      isLoading: false,
      error: null,

      // لاگین کاربر (با accessToken)
      login: (userData, accessToken) => {
        set({
          user: userData,
          accessToken,
          isLoggedIn: true,
          isLoading: false,
          error: null,
        });

        // تنظیم هدر Authorization برای تمام درخواست‌های بعدی axios
        axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
      },

      // بروزرسانی فقط accessToken (بعد از refresh)
      updateAccessToken: (newAccessToken) => {
        set({ accessToken: newAccessToken });
        axios.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;
      },

      // خروج کاربر
      logout: () => {
        set({
          user: null,
          accessToken: null,
          isLoggedIn: false,
          error: null,
        });

        // پاک کردن هدر
        delete axios.defaults.headers.common['Authorization'];

        // پاک کردن refreshToken از cookie (با درخواست به backend)
        axios.post('/auth/logout').catch(() => {
          console.log('رفرش توکن پاک شد');
        });
      },

      // تنظیم وضعیت لودینگ
      setLoading: (loading) => set({ isLoading: loading }),

      // تنظیم خطا
      setError: (error) => set({ error }),

      // تلاش برای دریافت توکن جدید (وقتی accessToken منقضی شد)
      refreshAccessToken: async () => {
        const { isLoggedIn } = get();
        if (!isLoggedIn) return;

        set({ isLoading: true });

        try {
          const response = await axios.post('/auth/refresh');
          const { accessToken } = response.data;

          get().updateAccessToken(accessToken);
          set({ isLoading: false, error: null });
          console.log('توکن جدید دریافت شد');
        } catch (error) {
          console.error('خطا در دریافت توکن جدید:', error.response?.data?.message || error.message);
          set({ isLoading: false, error: 'جلسه منقضی شده. لطفاً دوباره وارد شوید' });

          // اگر رفرش توکن هم نامعتبر بود → کاربر رو لاگ‌اوت کن
          get().logout();
        }
      },

      // چک کردن وضعیت توکن (اختیاری — برای استفاده در interceptor)
      getToken: () => get().accessToken,
    }),
    {
      name: 'auth-storage', // نام ذخیره در localStorage
      partialize: (state) => ({
        user: state.user,
        isLoggedIn: state.isLoggedIn,
      }),
      // توکن رو در localStorage ذخیره نمی‌کنیم (امنیت بیشتر)
    }
  )
);

export default useAuthStore;